export const HighlightIqLimitType = {
	CLIPS:    'clips',
	DURATION: 'duration',
};
